import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTenderFailuresPage() {
  return <LatamAgentPage locale="en-LATAM" agentKey="tender_failures" />;
}
